import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface TabSwitchItem {
  id: string;
  label: string;
  disabled?: boolean;
  icon?: string;
}

@Component({
  selector: 'app-tab-switch',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './tab-switch.component.html',
  styleUrls: ['./tab-switch.component.scss'],
})
export class TabSwitchComponent {
  @Input({ required: true }) tabs: ReadonlyArray<TabSwitchItem> = [];
  @Input({ required: true }) activeTab: string | null = null;
  @Input() ariaLabel = 'Tab switch';
  @Output() activeTabChange = new EventEmitter<string>();

  protected selectTab(tab: TabSwitchItem) {
    if (tab.disabled || tab.id === this.activeTab) {
      return;
    }
    this.activeTabChange.emit(tab.id);
  }
}
